"use client"

import ErrorBoundary from "@modules/common/components/error-boundary"

export default function MainError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  return (
    <ErrorBoundary
      error={error}
      reset={reset}
      heading="Something went wrong"
      message="We encountered an unexpected error. Please try again, or contact support if the problem persists."
    />
  )
}
